import styled from "styled-components";
import {
  mediaMaxWidth,
  mediaMinWidth,
} from "../../../utils/mediaQueriesTemplate";

export const ModalWrapper = styled.div``;

export const ModalButton = styled.button`
  font-weight: bold;
  color: #fff;
  background: #f2008c;
  border: 1px solid #f2008c;
  box-sizing: border-box;
  border-radius: 4px;
  line-height: 22px;
  text-rendering: optimizeLegibility;
  padding: 10px 12px;
  font-family: Raleway;
  text-align: center;
  letter-spacing: 0.03em;
  text-transform: capitalize;
  font-size: 1em;
  min-width: 100px;
  transition: 0.15s ease-in-out;

  &:focus {
    outline: none;
  }
`;

export const ModalContent = styled.div`
  background-color: #f4f4f4;
  margin: 15px auto;
  box-shadow: 0 0 5px rgb(136, 136, 136);
  border-radius: 4px;
  padding: 0;
  right: -100vw;
  transition: 0.1s ease-in-out;
  position: fixed;
  top: 0;
  width: 70vw;
  overflow: hidden;

  &.active {
    left: 0;
    right: 0;
    z-index: 2;
    height: 350px;
    width: 600px;
    top: calc(50% - 200px);

    ${mediaMaxWidth.smallDesktop`
      width: calc(70vw - 20px);
    `}

    ${mediaMaxWidth.tablet`
      width: calc(100vw - 30px);
      height: 400px;
      top: calc(50% - 200px);
    `}
  }

  ${mediaMinWidth.desktop`
    width: 50vw;
  `}

  ${mediaMaxWidth.tablet`
    width: calc(100vw - 10px);
    height: calc(100vh - 10px);
    margin: 5px auto;
  `}
`;

export const ModalHeader = styled.div`
  display: flex;
  background-color: #e4e5e7;
  justify-content: space-between;
  text-align: center;
  height: 45px;
  align-items: center;
`;

export const ModalTitle = styled.div`
  flex: 1;
  font-size: 1.3em;
  font-weight: 500;
`;

export const ModalCloseButton = styled.div`
  position: absolute;
  z-index: 1;
  right: 11px;
  font-size: 1.4em;
  top: 8px;
  background-color: #673490;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  cursor: pointer;
  transition: 0.1s ease-in-out;

  &:hover {
    background-color: #f2008c;
  }
`;

export const ModalBody = styled.div`
  margin: 0;
  overflow: scroll;
  height: calc(100vh - 25px);

  ${mediaMaxWidth.tablet`
    height: calc(100vh - 55px);
    overflow-x: hidden;
  `}
`;

export const TextAreaInput = styled.textarea`
  margin: 20px 10px 0;
  padding: 10px;
  height: 8em;
  width: calc(100% - 30px);
  resize: none;
  border: 1px solid #e0e0e0;
  box-sizing: border-box;
  border-radius: 4px;
  box-shadow: none;
  line-height: 1.42857143;
  color: #555555;
  font-style: italic;

  &:focus {
    border-color: #f2008c;
    outline: none;
    box-shadow: inset 0 1px 1px rgba(0,0,0,0.075), 0 0 8px rgba(233,102,163,0.6);
    }
  }

  ${mediaMaxWidth.tablet`
    height: 10em;
  `}
`;

export const Indicators = styled.div`
  height: 60px;
  margin: 15px 20px;
  display: flex;
  flex-direction: column;
`;

export const Minimum = styled.div`
  flex: 1;
  line-height: 1.375em;
  font-size: 0.9em;
  letter-spacing: 0.013em;
  font-weight: 500;

  &.done {
    color: #00a50e;
  }

  svg {
    width: 16px !important;
  }
`;

export const Remaining = styled.div`
  flex: 1;

  &.lowcharsleft {
    color: #f2008c;
    font-weight: 500;
    font-size: 0.98em;
  }
`;

export const ModalFooter = styled.div`
  text-align: center;
  position: absolute;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 60px;
  background: #e4e5e7;
`;
